<template>
  <div class="popup__layer active">
    <div class="popup__edit big">
      <div class="popup__close" @click="close(true)">
        <span class="glicon-close-large"></span>
      </div>
      <div class="popup__feedback">
        <div class="popup__feedback--image failed">
          <span class="glicon-alert-thin"></span>
        </div>
        <div class="popup__feedback--subtitle">
          {{ $t('account.forms.deactivateReferralTitle') }}
        </div>
        <div class="popup__feedback--text">
          {{ $t('account.forms.deactivateReferralText') }}
        </div>
        <div class="popup__feedback--text no-padding">
          {{ $t('account.forms.deactivateReferralTextSecondary') }}
        </div>
      </div>
      <div class="popup__buttons">
        <gl-button
          id="config.deactivate-referral"
          color-secondary
          :type="'button'"
          :text="$t('account.forms.deactivateReferral')"
          @onClick.prevent="close(false)"
        ></gl-button>
        <gl-button
          id="config.activate-referral"
          color-primary
          :type="'button'"
          :text="$t('account.forms.activateReferral')"
          @onClick.prevent="close(true)"
        ></gl-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupClientConfig',
  data() {
    return {
      checked: false
    };
  },
  methods: {
    close(accept) {
      this.$emit('close', accept);
    }
  }
};
</script>
